import CDN_BASE from '../../utils/cdn';

// Verbatim move of the legacy DEFAULT_LOGOS / RESIDENTIAL_LOGOS /
// BREWERY_LOGOS / COMMUNITY_LOGOS / PREMIUM_PROMO_LOGOS arrays from
// LogoList.jsx. Sourced from https://static.seattlefoodtruck.com/logos/.
const common = [
  { src: `${CDN_BASE}/logos/AmazonLogo-300x200.webp`, alt: 'Amazon' },
  { src: `${CDN_BASE}/logos/Bungie-300x200.webp`, alt: 'Bungie' },
  { src: `${CDN_BASE}/logos/comcastlogo-300x200.webp`, alt: 'Comcast' },
  { src: `${CDN_BASE}/logos/Expedia-300x200.webp`, alt: 'Expedia' },
  { src: `${CDN_BASE}/logos/googlelogo-300x200.webp`, alt: 'Google' },
  { src: `${CDN_BASE}/logos/MicrosoftLogo-300x200.webp`, alt: 'Microsoft' },
  { src: `${CDN_BASE}/logos/privateerholdingslogo-300x200.webp`, alt: 'Privateer Holdings' },
  { src: `${CDN_BASE}/logos/Starbucks-300x200.webp`, alt: 'Starbucks' },
];

const residential = [
  { src: `${CDN_BASE}/logos/Greystar.webp`, alt: 'Greystar' },
  { src: `${CDN_BASE}/logos/CBRE.webp`, alt: 'CBRE' },
  { src: `${CDN_BASE}/logos/AVA.webp`, alt: 'AVA' },
  { src: `${CDN_BASE}/logos/AvalonBAy.webp`, alt: 'AvalonBay' },
  { src: `${CDN_BASE}/logos/Equity.webp`, alt: 'Equity' },
  { src: `${CDN_BASE}/logos/Windermere.webp`, alt: 'Windermere' },
];

const breweries = [
  { src: `${CDN_BASE}/logos/BlackRaven.webp`, alt: 'Black Raven' },
  { src: `${CDN_BASE}/logos/Broadview.webp`, alt: 'Broadview' },
  { src: `${CDN_BASE}/logos/Locus.webp`, alt: 'Locus' },
  { src: `${CDN_BASE}/logos/Rooftop.webp`, alt: 'Rooftop' },
  { src: `${CDN_BASE}/logos/UrbanFamily.webp`, alt: 'Urban Family' },
  { src: `${CDN_BASE}/logos/Figurehead.webp`, alt: 'Figurehead' },
];

const community = [
  { src: `${CDN_BASE}/logos/Bumbershoot.webp`, alt: 'Bumbershoot' },
  { src: `${CDN_BASE}/logos/TasteWA.webp`, alt: 'Taste WA' },
  { src: `${CDN_BASE}/logos/Pridefest.webp`, alt: 'Pridefest' },
  { src: `${CDN_BASE}/logos/Sasquatch.webp`, alt: 'Sasquatch' },
  { src: `${CDN_BASE}/logos/QAFarmers.webp`, alt: 'Queen Anne Farmers Market' },
];

// 5-item subset of `common`. Used by Subscription.jsx (vendor side) for
// the "Companies Who Use Our Site" panel rendered without an h2 title.
// Kept distinct in case the curated subset diverges from `common` later.
const premiumPromo = [
  { src: `${CDN_BASE}/logos/AmazonLogo-300x200.webp`, alt: 'Amazon' },
  { src: `${CDN_BASE}/logos/Bungie-300x200.webp`, alt: 'Bungie' },
  { src: `${CDN_BASE}/logos/comcastlogo-300x200.webp`, alt: 'Comcast' },
  { src: `${CDN_BASE}/logos/Expedia-300x200.webp`, alt: 'Expedia' },
  { src: `${CDN_BASE}/logos/googlelogo-300x200.webp`, alt: 'Google' },
];

export default { common, residential, breweries, community, premiumPromo };
